<template>
  <div>
    <span @click="dialog = !dialog">
      <slot> </slot>
    </span>
    <v-dialog v-model="dialog" max-width="690px">
      <v-card>
        <v-card-text class="pb-0">
          <v-col cols="12" style="text-align: center" v-if="!loaded">
            <v-progress-circular indeterminate color="primary" size="105" />
            <h3 class="mt-4">{{ $t("global.loading") }}</h3>
          </v-col>
          <v-col cols="12" v-else class="pb-0">
            <fieldset class="custom-fieldset">
              <legend>{{ $t("travelService.outdatedOffer") }}</legend>
              <v-row>
                <v-col md="9" v-if="model.html != null && model.html.length !== 0">
                  <w-y-s-i-w-y-g-html-element :html="model.html" />
                </v-col>
                <v-col md="9" v-if="type === 'hotel' && (model.html == null || model.html.length === 0)" cols="12">
                  <hotel-response-presentation :offer="model" />
                </v-col>
                <v-col md="9" v-if="type === 'car' && (model.html == null || model.html.length === 0)" cols="12">
                  <car-response-presentation :offer="model" />
                </v-col>
                <v-col md="9" v-if="type === 'flight' && (model.html == null || model.html.length === 0)" cols="12">
                  <flight-response-presentation :offer="model" />
                </v-col>
                <v-col md="9" v-if="type === 'rail' && (model.html == null || model.html.length === 0)" cols="12">
                  <rail-response-presentation :offer="model" />
                </v-col>
                <v-col class="pl-3" md="3" cols="12">
                  <v-text-field :label="$t('global.amount')" :value="model.price + ' ' + model.currency" outlined readonly />
                  <div class="text-center my-3" style="width: 100%">
                    <v-icon color="primary" style="font-size: 100px">{{ bookingIconType(type) }}</v-icon>
                  </div>
                </v-col>
              </v-row>
            </fieldset>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click.native="dialog = false">{{ $t("global.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import WYSIWYGHtmlElement from "../Shared/WYSIWYGHtmlElement";
import HotelResponsePresentation from "./OfferPresentation/HotelResponsePresentation";
import CarResponsePresentation from "./OfferPresentation/CarResponsePresentation";
import FlightResponsePresentation from "./OfferPresentation/FlightResponsePresentation";
import RailResponsePresentation from "./OfferPresentation/RailResponsePresentation";
import { bookingIconType } from "../../staticData/ServiceOrder";

export default {
  name: "OfferArchiveDialog",
  components: { RailResponsePresentation, FlightResponsePresentation, CarResponsePresentation, HotelResponsePresentation, WYSIWYGHtmlElement },
  props: {
    id: {
      required: true
    },
    isAdmin: {
      required: true
    },
    type: {
      required: true
    }
  },
  data: () => ({
    dialog: false,
    model: null,
    loaded: false
  }),
  watch: {
    dialog(val) {
      if (val && !this.loaded) {
        this.downloadArchiveItem();
      }
    }
  },
  methods: {
    downloadArchiveItem() {
      let address = "travel-service/get-archived-travel-service-order-item-response-option";
      if (this.isAdmin) {
        address = "admin/travel-service-admin/get-archived-travel-service-order-item-response-option";
      }
      this.axios.get(address + "?optionId=" + this.id).then(resp => {
        this.model = resp.data;
        this.loaded = true;
      });
    },
    bookingIconType
  }
};
</script>

<style scoped></style>
